import { useSettings } from '../hooks/useSettings';
import { useAuth } from '../contexts/AuthContext';

interface HeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
}

export function Header({ title, subtitle, actions }: HeaderProps) {
  const { settings, loading } = useSettings();
  const { user } = useAuth();

  const getUserRoleText = (role: string) => {
    switch (role) {
      case 'ADMIN':
        return 'Administrador';
      case 'USER':
        return 'Usuário';
      default:
        return 'Usuário';
    }
  };

  return (
    <header className="bg-white border-b border-gray-200 px-3 py-3 sm:px-6 sm:py-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        {/* Título e Subtítulo */}
        <div className="flex min-w-0 items-center space-x-4">
          {/* Logo da empresa no header */}
          <div className="flex min-w-0 items-center space-x-3">
            {!loading && (
              <img
                src={settings?.logoUrl || '/assets/default-logo.png'}
                alt={settings?.companyName || 'Astra Online'}
                className="hidden h-8 w-auto object-contain sm:block"
              />
            )}
            {loading && (
              <div className="hidden h-8 w-24 animate-pulse rounded bg-gray-200 sm:block"></div>
            )}
            <div className="min-w-0 sm:border-l sm:border-gray-300 sm:pl-3">
              <h1 className="truncate text-lg font-semibold text-gray-900 sm:text-xl">{title}</h1>
              {subtitle && (
                <p className="truncate text-sm text-gray-500">{subtitle}</p>
              )}
            </div>
          </div>
        </div>

        {/* Ações da direita */}
        {/* Seletor de empresa e saldo de créditos NÃO vivem mais aqui: os dois ficam na
            GlobalTopBar, que é comum a todos os módulos (CRM, Seller, Marketing, Flow).
            Mantê-los também neste header de página duplicava o controle só no CRM. */}
        <div className="flex flex-wrap items-center gap-2 sm:gap-4">
          {/* Avatar do usuário */}
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 rounded-full flex items-center justify-center" style={{ backgroundColor: 'var(--astra-dark-blue)' }}>
              <span className="text-white text-sm font-medium">
                {user?.nome?.charAt(0)?.toUpperCase() || 'U'}
              </span>
            </div>
            <div className="hidden sm:block">
              <p className="text-sm font-medium text-gray-900">{user?.nome || 'Usuário'}</p>
              <p className="text-xs text-gray-500">{getUserRoleText(user?.role || 'USER')}</p>
            </div>
          </div>

          {/* Ações customizadas */}
          {actions && (
            <div className="flex items-center space-x-2 border-l border-gray-200 pl-4">
              {actions}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}